import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';

// https://router.vuejs.org/en/
Vue.use(Router);

export default new Router({
	routes
});



// WEBPACK FOOTER //
// ./sources/router/index.js